<template>
    <Tooltip class="p-10 ml-n5 bg-light-danger text-danger border-light-danger" :disabled="accountIssues.length === 0">
        <template v-slot:trigger>
            <div v-if="accountIssues.length > 0"
                 class="user-select-none w-100 h-100"
                 :class="[iconColor]"
            >
                <i class="fas fa-exclamation-triangle"/>
            </div>
            <div v-else class="text-muted">
                <i class="fas fa-times" />
            </div>
        </template>

        <div v-if="accountIssues.length > 0" class="d-flex flex-column gap-4 max-w-400px">
            <div v-for="issue in accountIssues" class="text-nowrap">
                <div class="font-size-lg font-weight-bold mb-1">
                    {{ issue.title }}
                </div>
                <div class="font-size-sm text-wrap">
                    {{ issue.detail || 'No details available' }}
                </div>
            </div>
        </div>
        <i v-else class="fas fa-times"/>
    </Tooltip>
</template>

<script>
import Tooltip from "@components/Tooltip.vue";

export default {
    components: {Tooltip},

    props: {
        accountIssues: {
            type: Array,
            required: true
        }
    },

    computed: {
        iconColor() {
            if (this.accountIssues.length === 0 || this.accountIssues.length === 1 && this.accountIssues[0].id === 'missing_ad_words_link') {
                return 'text-muted';
            } else if (this.accountIssues.length > 1) {
                return 'text-danger'
            }

            return 'text-muted';
        }
    }
}
</script>
